import {TCITenantAppType} from "./tci-application";
import {TCITenantSelectorType} from "./tci-tenant";
import {strEnum} from "../../types";

// tslint:disable:no-empty-interface

/**
 * TCI_COMPONENT_MODE Type enumerations
 * @type {{[K in string | string | string | string | string | string | string | string]:K}}
 */
export const TCI_COMPONENT_MODE = strEnum([
    "COMP_MODE_APP_DEFAULT",
    "COMP_MODE_APP_MAIN_MENU",
    "COMP_MODE_APP_LIST",
    "COMP_MODE_APP_DETAIL",
    "COMP_MODE_APP_DETAIL_HEADER",
    "COMP_MODE_APP_DETAIL_HAMBURGER_MENU",
    "COMP_MODE_APP_DETAIL_MENU",
    "COMP_MODE_CONN_HAMBURGER",
    "COMP_MODE_APP_DETAIL_SUBMENU"
]);
export type TCI_COMPONENT_MODE = keyof typeof TCI_COMPONENT_MODE;

export interface ITCITenantComponentInput {
    /**
     * TCI tenant app type
     */
    tenantAppType?: TCITenantAppType;

    /**
     * route to the module  e.g. e.g. wi-studio/client/app/flowslist/flowsList.module
     */
    moduleRoute?: string;

    /**
     * Module class name  e.g. FlowsListModule
     */
    moduleClass?: string;

    /**
     * component selector without the html tag delimiters e.g. app-create
     */
    componentSelector?: TCITenantSelectorType;
    /**
     * Mode in which this component is being launched
     */
    mode?: TCI_COMPONENT_MODE | string;
}

/**
 *
 */
export interface ITCITenantComponentOutput<E> {
}


